
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/aiblogger",
      function () {
        return require("private-next-pages/dashboard/aiblogger/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/aiblogger"])
      });
    }
  